import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-197">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-198">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-black/80 backdrop-blur-sm cursor-pointer" data-id="element-199" />

          {/* Modal Content */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        type: 'spring',
        duration: 0.5,
        bounce: 0.3
      }} className="relative w-full max-w-2xl max-h-[85vh] flex flex-col bg-brand-card border border-gray-800 rounded-2xl shadow-2xl overflow-hidden" data-id="element-200">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-800 shrink-0" data-id="element-201">
              <h2 className="text-xl font-bold text-white" data-id="element-202">{title}</h2>
              <button onClick={onClose} className="p-2 text-gray-400 transition-colors rounded-lg hover:text-white hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-brand-orange" aria-label="Cerrar modal" data-id="element-203">
                <X className="w-5 h-5" data-id="element-204" />
              </button>
            </div>

            {/* Body */}
            <div className="p-6 overflow-y-auto text-gray-300 custom-scrollbar" data-id="element-205">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}